import "../components/CustomerCardStyles.css"
import CustomerCard from "../components/CustomerCard"
import CustomerCardData from "../components/CustomerCardData"

import React from 'react'
import { useTranslation } from "react-i18next"

const Customers = () => {
  const { t } = useTranslation()
  return (
    <section className="customer-section" id="customer-section">  
      <div className="customers-container">
          <h1 className="customer-heading">{t('customers')}</h1>
          <hr className="small-hr"></hr>
          <div className="customer-container">
              {CustomerCardData.map((val,ind)=>{
                  return(<CustomerCard 
                      key={ind}
                      imgsrc={val.imgsrc}
                      />
                      )
              })}      
          </div>
      </div>
      </section>  
  )
}

export default Customers